/* Uniko · fiches produit : barre fixe mobile (un seul bouton, qui s'adapte à l'endroit où l'on se trouve). Aucun envoi de données, aucune logique de commande modifiée : le bouton renvoie au formulaire ou clique le vrai bouton d'ajout au panier. */
(function () {
  var bar = document.querySelector('[data-uk-sticky]');
  if (!bar) return;
  var btn = bar.querySelector('[data-uk-sticky-btn]');
  var mq = window.matchMedia('(max-width: 699px)');
  var action = null;
  function atc() { return document.querySelector('.product-info__buy-buttons button[type="submit"]'); }
  function formulaire() { return document.querySelector('.tee-form-wrapper'); }
  function choix() { return document.querySelector('.product-info__variant-picker'); }
  function visible(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.height > 0 && r.bottom > 0 && r.top < window.innerHeight; }
  function plusBas(el) { return !!el && el.getBoundingClientRect().top >= window.innerHeight; }
  var doux = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function aller(el) {
    var y = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - 90), avant = window.pageYOffset;
    if (!doux) { window.scrollTo(0, y); return; }
    window.scrollTo({ top: y, behavior: 'smooth' });
    // repli : si le défilement doux n'a pas démarré, on y va directement
    setTimeout(function () { if (Math.abs(window.pageYOffset - avant) < 2) window.scrollTo(0, y); }, 500);
  }
  function regler(texte, fn) { if (btn.textContent !== texte) btn.textContent = texte; action = fn; }
  function maj() {
    var b = atc();
    if (!mq.matches || !b) { bar.hidden = true; return; }
    var f = formulaire(), c = bar.getAttribute('data-choix') ? choix() : null;
    var cacher = visible(b) || (f && visible(f));
    bar.hidden = cacher;
    document.documentElement.classList.toggle('uk-sticky-on', !cacher);
    if (cacher) return;
    if (f && plusBas(f)) regler('Personnaliser', function () { aller(f); });
    else if (c && plusBas(c)) regler(bar.getAttribute('data-choix'), function () { aller(c); });
    else regler('Ajouter au panier', function () {
      b.click();
      // si le personnalisateur refuse (champ obligatoire vide), on amène le client sur le premier champ à compléter
      setTimeout(function () { var x = document.querySelector('.tee-field--invalid'); if (x) aller(x); }, 400);
    });
  }
  btn.addEventListener('click', function () { if (action) action(); });
  var att = false;
  function demande() { if (att) return; att = true; requestAnimationFrame(function () { att = false; maj(); }); }
  window.addEventListener('scroll', demande, { passive: true });
  window.addEventListener('resize', demande);
  if (mq.addEventListener) mq.addEventListener('change', demande);
  // le personnalisateur arrive après le chargement : on recalcule quelques secondes
  var n = 0, t = setInterval(function () { maj(); if (++n > 20) clearInterval(t); }, 1000);
  maj();
})();
